// Utils
import type { NotificationReportsProps } from '@/utils/hooks/context/toast/types';

// Routes
import { REPORTS } from '@/lib/routes/privateRoutes';

// Component
import { GREEN } from '@/components/base/Button';
import Notification from '@/components/base/Notification';

const ReportReady = ({ notification }: NotificationReportsProps) => {
    return (
        <Notification
            type={GREEN}
            dataNotification={notification}
            goToUrl={`${REPORTS}#history-reports-table`}
            contentHidden={notification?.options?.hideContent ?? false}
            wide={notification?.options?.wide ?? true}>
            <Notification.Icon icon="reports" />
            <Notification.Content>
                <Notification.Title i18nKey="commons:notifications.report_ready.title" />
                <Notification.Description
                    i18nKey="commons:notifications.report_ready.description"
                    values={{
                        report_name: notification?.data?.report_name
                    }}
                />
            </Notification.Content>
        </Notification>
    );
};

export default ReportReady;
